<script lang="ts" setup>
import { useLoaderStore } from '~/store/loader'

const loaderStore = useLoaderStore()
</script>

<template>
  <div>
    <div
      v-if="loaderStore.getLoader"
      :class="{ 'loading-overlay flex items-center justify-center': true, hidden: !loaderStore.getLoader }">
      <Loader />
    </div>
  </div>
</template>

<style lang="postcss">
.loading-overlay {
  background: #b1b7bf4a;
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  transition: all 0.5s ease-in-out;
  visibility: visible;
  z-index: 999999;

  &.hidden {
    display: none;
  }
}
</style>
